// #52 Banner, #80 Banner tone="red", #81 Banner tone="neutral": a state sentence in his words on the card surface
// with a 3 px left rule in the tone's hue and the tone's icon. Red is the breach tier and the refused state (DC-24);
// neutral is Cancelled / Archived. `live` makes it an alert (announced when it appears). Never a toast.

import type { ReactNode } from "react";
import { cx } from "../lib/cx";
import { Icon, type IconName } from "./icons";

export type BannerTone = "ok" | "info" | "warn" | "flag" | "red" | "neutral";

const ICON: Readonly<Record<BannerTone, IconName>> = {
  ok: "check", info: "eye", warn: "alert", flag: "flag", red: "alert", neutral: "archive",
};

export interface BannerProps {
  children: ReactNode;
  /** Default ok. */
  tone?: BannerTone | undefined;
  icon?: IconName | undefined;
  /** Right-aligned meta or one action. */
  right?: ReactNode | undefined;
  /** role="alert". */
  live?: boolean | undefined;
  className?: string | undefined;
}

export function Banner({ children, tone = "ok", icon, right, live, className }: BannerProps) {
  return (
    <div className={cx("mc-banner", `mc-banner-${tone}`, className)} role={live ? "alert" : undefined}>
      <Icon name={icon ?? ICON[tone]} size={18} />
      <div className="mc-banner-t">{children}</div>
      {right ? <div className="mc-banner-r">{right}</div> : null}
    </div>
  );
}
